import { useLocation } from 'react-router-dom'
import Wrapper from './Nav.styles'
import { Link } from 'react-router-dom'
import { NavigationRoutes } from '../../Constants/Routes'
import { resetChartCategoriesCache } from '../../Hooks/useChartCategories'

export const Nav = ({ allowChart }) => {
    const location = useLocation()
    const path = location.pathname.split('/').filter((c) => c !== '')
    const isSupportActive = location.pathname.includes('Support');;
    const activeRoot = path.length ? '/' + path[0] : '';
    const refreshChartPermissions = () => {
        resetChartCategoriesCache();
    };

    return (
        <Wrapper>
            <Link to={NavigationRoutes.HOME} className="title">Global Growth Cube</Link>
            <ul>
                <li><Link to={NavigationRoutes.DOWNLOAD_DATA} className={activeRoot === NavigationRoutes.DOWNLOAD_DATA ? "active" : ""}>Database Access</Link></li>
                {allowChart ? (
                    <>
                        <li><Link to={NavigationRoutes.MARKET_SNAPSHOT} className={activeRoot === NavigationRoutes.MARKET_SNAPSHOT ? "active" : ""} onClick={refreshChartPermissions}>Market Snapshot</Link></li>
                        <li><Link to={NavigationRoutes.VISUALIZE} className={activeRoot === NavigationRoutes.VISUALIZE ? "active" : ""} onClick={refreshChartPermissions}>Interactive Heatmaps</Link></li>
                    </>
                ) : null}
                <li><Link to={NavigationRoutes.PUBLICATIONS.ROOT} className={activeRoot === NavigationRoutes.PUBLICATIONS.ROOT ? "active" : ""}>Insights</Link></li>
                <li><Link to={NavigationRoutes.REPORTS} className={activeRoot === NavigationRoutes.REPORTS ? "active" : ""}>Library</Link></li>
                <li><Link to={NavigationRoutes.SUPPORT.FAQs} className={isSupportActive ? "active" : ""}>Support</Link></li>
                
            </ul>
        </Wrapper>
    )
}
